import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query';
import storage from 'redux-persist/lib/storage';
import { persistReducer, persistStore } from 'redux-persist';
import projectsPageReducer from './slices/projectsPageSlice';
import dialogReducer from './slices/dialogSlice';
import userReducer from './slices/userSlice';
import { calculationsApi } from './services/calculations';
import { projectApi } from './services/projects';
import { standardsApi } from './services/standards';
import { temperatureDataApi } from './services/temperatures';
import { productDataApi } from './services/products';
import { supportWidthsApi } from './services/supportWidths';

const persistConfig = {
  key: 'root',
  storage,
};

const persistedUserReducer = persistReducer(persistConfig, userReducer);

export const store = configureStore({
  reducer: {
    projectsPage: projectsPageReducer,
    dialog: dialogReducer,
    user: persistedUserReducer,
    [calculationsApi.reducerPath]: calculationsApi.reducer,
    [projectApi.reducerPath]: projectApi.reducer,
    [standardsApi.reducerPath]: standardsApi.reducer,
    [temperatureDataApi.reducerPath]: temperatureDataApi.reducer,
    [productDataApi.reducerPath]: productDataApi.reducer,
    [supportWidthsApi.reducerPath]: supportWidthsApi.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      calculationsApi.middleware,
      projectApi.middleware,
      standardsApi.middleware,
      temperatureDataApi.middleware,
      productDataApi.middleware,
      supportWidthsApi.middleware
    ),
});

setupListeners(store.dispatch);

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;

export type AppDispatch = typeof store.dispatch;
